module.exports = __webpack_public_path__ + "acorn-broken.4bce28eb8c6c4285cf0f40f180f17750.svg";